// 캠페인 노출 기간 설정. 이 기간을 벗어나면 GNB/플로팅 배너에서 숨기고,
// 이벤트 페이지 자체는 종료 안내 모달을 띄운다.
export const EVENT_2607_PERIOD = {
    start: '2026-07-15T10:00:00+09:00',
    end: '2026-07-31T17:00:00+09:00',
};

export function isEventLive(period) {
    const now = new Date();
    return now >= new Date(period.start) && now <= new Date(period.end);
}

export function isEventUpcoming(period) {
    return new Date() < new Date(period.start);
}

export function isEventOver(period) {
    return new Date() > new Date(period.end);
}
